/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useState} from 'react'
import axios from 'axios'

const API_URL = 'http://localhost:4000'

export const BoilerPlatePage: FC = () => {
  const [message, setMessage] = useState('')
  const [responseMessage, setResponseMessage] = useState('')

  const sendMessage = async () => {
    try {
      const response = await axios.post(`${API_URL}/api/message`, {
        message: message,
      })
      setResponseMessage(response.data.response)
    } catch (error) {
      console.error('Error sending message:', error)
    }
  }

  return (
    <div style={{padding: '1rem'}}>
      <h2>Send a message to the backend</h2>
      <input
        type='text'
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder='Enter your message'
      />
      <button onClick={sendMessage} style={{marginLeft: '0.5rem'}}>
        Send
      </button>

      {responseMessage && (
        <p style={{marginTop: '1rem'}}>
          Response from server: <strong>{responseMessage}</strong>
        </p>
      )}
    </div>
  )
}
